



























































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Meter from '@/data/models/meter';
import Button from '@/components/commons/Button.vue';
import {IconMeter, MeterType, MeterTypeSelectable, Status, UnitType} from '@/data/models/enums/meter-enum';
import {requiredRule} from '@/helpers/rules-validator';
import {REF_METER_TYPE} from '@/constants';

@Component({
  components: {Button},
})
export default class CreateUpdateMeter extends Vue {

  @Prop({required: true})
  meter: Meter;

  @Prop({required: true})
  opened: boolean;

  isReference: boolean = false;
  isFormValid: boolean = true;
  referenceMeters: Meter[] = [];
  loadingReferences: boolean = false;
  selectedMeter: Meter[] = [];
  electricalMeterList: { text: string, value: string }[] = [];
  electricalMeterListLoading: boolean = true;
  allMeters: Meter[] = [];
  selectedMeterFormula: Meter = null;
  evaluatedFormula: string = "";

  driftSelectedMeters: Meter[] = null;
  driftEvaluationResult: any = "";

  headers = [
    {text: 'Identifiant', value: 'id'},
    {text: 'Nom', value: 'name'},
    {text: 'Type', value: 'type'},
    {text: 'Bâtiment', value: 'buildingId'},
  ];

  mounted(): void {
    this.loadingReferences = true;
    this.selectedMeter = null;

    this.$dao.meters.getReferencesMeters()
        .then((meters) => {
          if (meters != null) {
            meters.sort((a, b) => a.name.localeCompare(b.name));
            this.referenceMeters = meters;
          }
        })
        .finally(() => this.loadingReferences = false);
  }

  @Watch('meter', {immediate: true})
  onMeterChanged(): void {
    this.driftEvaluationResult = "";
    if (!this.meter) {
      return
    }
    this.$dao.meters.getAllByBuilding(this.meter.buildingId)
        .then((meters) => meters.filter(it => it.name))
        .then((meters) => {
          if (meters != null) {
            meters.sort((a, b) => a.name.localeCompare(b.name));
            this.allMeters = meters;
          }
        });

  }

  @Watch('selectedMeterFormula')
  onSelectedMeterFormulaChanged(): void {
    if (this.selectedMeterFormula != null) {
      this.meter.formula = `${this.meter.formula ?? ""} {{${this.selectedMeterFormula}}}`;
    }

    this.selectedMeter = null;
  }

  @Watch('driftSelectedMeters')
  onDriftSelectedMetersChanged(): void {
    if (this.driftSelectedMeters != null) {
      this.meter.drift_formula = `${this.meter.drift_formula ?? ""} {{SUM(${this.driftSelectedMeters})}}`;
    }

    this.driftSelectedMeters = null;
  }

  @Watch('meter.formula')
  async onFormulaChange(): Promise<void> {
    const payload = {}

    try {
      // On récupère les valeurs des compteurs utilisés dans la formule
      if (this.meter.arithmeticsReferencesIds.length > 0) {
        (await this.$dao.meters.getLastValues(this.meter.arithmeticsReferencesIds)).forEach((it) => payload[it.meterId] = it.value);
      }

      // On ajoute les compteurs manquantes (qui n'ont pas de valeur en base)
      this.meter.arithmeticsReferencesIds.forEach((id) => {
        if (!payload[id]) payload[id] = 0;
      });

      // On évalue la formule
      this.evaluatedFormula = this.meter.evaluateFormula(payload).toString();
    } catch (e) {
      this.evaluatedFormula = "Erreur";
    }
  }

  @Watch('dialog', {immediate: true})
  onDialogChanged(open: boolean): void {
    if (open) {
      if (this.meter.referenceMeterId != null) {
        this.isReference = true;
        this.selectedMeter = [this.referenceMeters.find((meter) => meter.id == this.meter.referenceMeterId)];
      }

      this.electricalMeterListLoading = true;
      this.$dao.meters
          .getAllByBuilding(this.meter.buildingId)
          .then(meters => meters.filter(it => it.type === MeterType.ELECTRICTY))
          .then(meters => meters.map(it => ({'text': it.name, 'value': it.id})))
          .then(meters => {
            meters.push({'text': 'Aucun', value: undefined});
            return this.electricalMeterList = meters;
          })
          .finally(() => this.electricalMeterListLoading = false)
    }
  }

  get allMeterWithoutFormulasOne(): Meter[] {
    return this.allMeters.filter(it => this.formulaMeters.find(meter => meter.id === it.id) == null).filter(it => it.id !== this.meter.id);
  }

  get formulaMeters(): { id: string, name: string }[] {
    return this.meter.arithmeticsReferencesIds
        .map(it => {
          return {
            id: it,
            name: this.allMeters.find(meter => meter.id === it)?.name ?? "Inconnu"
          }
        })
  }

  get driftFormulaMeters(): { id: string, name: string }[] {
    return this.meter.driftReferencesIds
        .map(it => ({
          id: it,
          name: this.allMeters.find(meter => meter.id === it)?.name ?? it
        }))
  }

  get isCreated(): boolean {
    return this.meter.id == null;
  }

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
    this.selectedMeter = [];
    this.isReference = false;
  }

  get typeItems(): any {
    return Object.values(MeterTypeSelectable).map((item) => {
      return {'text': this.$t(`meter.types.${item}`), 'value': item};
    });
  }

  get unitItems(): any {
    return Object.values(UnitType).map((item) => {
      return {'text': this.$t(`meter.units.${item}`), 'value': item};
    });
  }

  get statusItems(): any {
    return Object.values(Status).map((item) => {
      return {'text': this.$t(`meter.status.${item}`), 'value': item};
    });
  }

  get requiredRule(): any {
    return requiredRule(this.$t('rules.required.empty').toString());
  }

  get dataloggerMacRule(): Array<(v: string) => boolean | string> {
    return [(v: string): boolean | string => !v || /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/i.test(v) || 'Format attendu : 38:18:2B:E4:B1:7C'];
  }

  get canBeRef(): boolean {
    return REF_METER_TYPE.includes(this.meter.type);
  }

  driftEvaluation(): void {
    this.$dao.meters.evaluateDriftFormula(this.meter.id, this.meter.drift_formula)
        .then((result) => {
          this.driftEvaluationResult = result;
        });
  }

  goTo(path: string): void {
    this.$router.replace(path);
    this.$emit('close', undefined);
  }

  icon(item: string): string {
    return IconMeter[item];
  }

  handleClick(): void {
    this.$store.commit("showLoader", true);
    this.isCreated ? this.create() : this.update();
  }

  requestArchive(): void {
    if (confirm("Voulez-vous vraiment archiver ce compteur ?")) {
      this.$store.commit("showLoader", true);
      this.$dao.meters.archive(this.meter.id).then((result) => {
        if (result != null) {
          this.dialog = false;
        } else {
          throw 'err';
        }
      }).catch(() => {
        this.$dialog.error({text: this.$t('errors.archiveMeter').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
      }).finally(() => this.$store.commit("showLoader", false));
    }
  }

  create(): void {
    if (this.isReference) {
      this.meter.isReference = false;
      this.meter.referenceMeterId = this.selectedMeter[0].id;
      this.meter.type = this.selectedMeter[0].type
    }

    this.$dao.meters.create(this.meter).then((result) => {
      if (result != null) {
        this.dialog = false;
      } else {
        throw 'err';
      }

    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.createMeter').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }

  update(): void {
    this.$store.commit("showLoader", true);

    if (this.isReference) {
      this.meter.isReference = false;
      this.meter.referenceMeterId = this.selectedMeter[0].id;
      this.meter.type = this.selectedMeter[0].type;
    } else {
      this.meter.referenceMeterId = null;
    }

    this.$dao.meters.update(this.meter, this.meter.id).then((result) => {
      if (result != null) {
        this.dialog = false;
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.updateMeter').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }

}
